import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Group Agen: ", -1)
const _hoisted_4 = { class: "text-sm color-red" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "inline-block" }
const _hoisted_9 = { class: "color-blue-grey text-sm font-bold" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-down color-blue-grey" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "text-white font-bold text-sm text-center" }, "Simpan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.store.state.appActiveUser.agent.NamaGroupKota), 1)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.data,
          paginator: false,
          stripedRows: "",
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Nama Agen",
              style: {"width":"25%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_5, _toDisplayString(slotProps.data.Nama), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kurir Dimiliki",
              style: {"width":"25%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_6, _toDisplayString(slotProps.data['KurirMsUsers@odata.count']), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kurir Absen Masuk",
              style: {"width":"25%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_7, _toDisplayString(slotProps.data['KurirTransAbsensiMsAgenIdInNavigations@odata.count']), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kebutuhan Jumlah Kurir",
              style: {"width":"25%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_8, [
                  (slotProps.data.Id === _ctx.store.getters['appActiveUser/getAgent']?.id)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "background-grey-lighten-5 px-3 py-1 gap-2 flex items-center rounded-lg cursor-pointer",
                        onClick: ($event: any) => (_ctx.changeCanChange($event, slotProps.data, slotProps.index))
                      }, [
                        _createVNode("p", _hoisted_9, "Kuota Kurir: " + _toDisplayString(slotProps.data?.Kuota), 1),
                        _hoisted_10
                      ], 8, ["onClick"]))
                    : (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(slotProps.data?.Kuota), 1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "refChangeKuota" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_InputNumber, {
            class: "input-primary rounded-lg mt-1 mb-3",
            modelValue: _ctx.dataForm.Kuota,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataForm.Kuota = $event)),
            showButtons: "",
            buttonLayout: "horizontal",
            incrementButtonIcon: "pi pi-plus",
            decrementButtonIcon: "pi pi-minus",
            min: 0,
            placeholder: "Kuota"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            class: "font-semibold btn-primary p-button-sm w-full flex justify-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512)
  ]))
}